import { render, staticRenderFns } from "./CreateMouMoaModal.vue?vue&type=template&id=ce416f52"
import script from "./CreateMouMoaModal.vue?vue&type=script&lang=js"
export * from "./CreateMouMoaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports